import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./AddPurchase.css";
import axios from "axios";

const AddTask = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const [customerList, setCustomers] = useState([]);

  const [formData, setFormData] = useState({
    task_theme: "",
    task_name: "",
    description: "",
    priority: "",
    due_date: "",
    status: "Assigned",
    assigned_to: "",
    assigned_by: "",
    created_at: "",
    auto_creation: "0",
    day: "",
  });

  const [errors, setErrors] = useState({});

  // Set creation timestamp on mount
  // useEffect(() => {
  //   const now = new Date().toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm
  //   setFormData((prev) => ({
  //     ...prev,
  //     created_at: now,
  //   }));
  // }, []);

  // Generic field update
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const v = {};
    if (!formData.task_theme.trim()) v.task_theme = "Theme is required";
    if (!formData.task_name.trim()) v.task_name = "Title is required";
    if (!formData.priority) v.priority = "Select priority";
    if (!formData.due_date) v.due_date = "Select due date";
    if (!formData.status) v.status = "Select status";
    if (!formData.assigned_to.trim()) v.assigned_to = "Assigned To is required";
    if (!formData.assigned_by.trim()) v.assigned_by = "Assigned By is required";
    return v;
  };

  useEffect(() => {
    axios.post(`${API_BASE_URL}user_list.php`)
      .then((response) => {
        if (response.data.head.code === 200 && Array.isArray(response.data.body)) {
          setCustomers(response.data.body);
          // setFilteredOrders(response.data.body);

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          setCustomers([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        setCustomers([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length) {
      setErrors(validationErrors);
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    setErrors({});
    const payload = {
      ...formData,
      due_date: formData.due_date
        ? new Date(formData.due_date).toISOString().split("T")[0]
        : "",
    };

    console.log("Task Submitted:", payload);
    // TODO: send to backend
    axios.post(`${API_BASE_URL}task_add.php`, payload)
      .then((response) => {
        // console.log("=========",response);
        if (response.data.head.code === 200) {
          // setDepartmentList(response.data.body);
          // setFilteredOrders(response.data.body);
          navigate("/task");
          // window.history.back();

        } else {
          console.error("Error Fetching Data:", response.data.head.msg);
          // setDepartmentList([]);
          // setFilteredOrders([]);
        }
      })
      .catch((error) => {
        console.error("API Error:", error);
        // setDepartmentList([]);
        // setFilteredOrders([]);
      }).finally(() => {
        // setLoading(false); // Set loading to false after API call
      });

    // navigate("/task");
  };

  const renderError = (field) =>
    errors[field] ? (
      <div className="text-danger small mt-1">{errors[field]}</div>
    ) : null;

  return (
    <Container className="my-4">
      <div className="form-header mb-4 d-flex justify-content-between align-items-center">
        <h4 className="mb-0">Create Task</h4>
        <Button className="btn-top" onClick={() => navigate(-1)}>
          Back
        </Button>
      </div>

      <Form onSubmit={handleSubmit} noValidate>
        <Row className="g-3">
          {/* Theme */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Theme</Form.Label>
              <Form.Control
                type="text"
                name="task_theme"
                value={formData.task_theme}
                onChange={handleChange}
                placeholder="Task Theme"
              />
              {renderError("task_theme")}
            </Form.Group>
          </Col>

          {/* Title */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                name="task_name"
                value={formData.task_name}
                onChange={handleChange}
                placeholder="Task title"
              />
              {renderError("task_name")}
            </Form.Group>
          </Col>

          {/* Priority */}
          <Col lg={4} md={12}>
            <Form.Group>
              <Form.Label>Priority</Form.Label>
              <Form.Select
                name="priority"
                value={formData.priority}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Priority</option>
                <option value="Low">Low</option>
                <option value="Medium">Medium</option>
                <option value="High">High</option>
                <option value="Critical">Critical</option>
              </Form.Select>
              {renderError("priority")}
            </Form.Group>
          </Col>

          {/* Description */}
          <Col lg={12}>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={formData.description}
                onChange={handleChange}
                placeholder="Short description of the task"
              />
            </Form.Group>
          </Col>

          {/* Due Date */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Due Date</Form.Label>
              <Form.Control
                type="date"
                name="due_date"
                value={formData.due_date}
                onChange={handleChange}
              />
              {renderError("due_date")}
            </Form.Group>
          </Col>

          {/* Status */}
          {/* <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Status</option>
                <option value="Pending">Pending</option>
                <option value="In Progress">In Progress</option>
                <option value="Completed">Completed</option>
                <option value="Cancelled">Cancelled</option>
              </Form.Select>
              {renderError("status")}
            </Form.Group>
          </Col> */}

          {/* Assigned To */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Assigned To</Form.Label>
              <Form.Select
                name="assigned_to"
                value={formData.assigned_to}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Assignee</option>
                {customerList.map((user) => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.name}
                  </option>
                ))}
                {/* add more users here */}
              </Form.Select>
              {renderError("assigned_to")}
            </Form.Group>
          </Col>

          {/* Assigned By */}
          <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Assigned By</Form.Label>
              <Form.Select
                name="assigned_by"
                value={formData.assigned_by}
                onChange={handleChange}
                className="custom-select-arrow"
              >
                <option value="">Select Assigner</option>
                {customerList.map((user) => (
                  <option key={user.user_id} value={user.user_id}>
                    {user.name}
                  </option>
                ))}
                {/* add more assigners here */}
              </Form.Select>
              {renderError("assigned_by")}
            </Form.Group>
          </Col>


          {/* Created At */}
          {/* <Col lg={6} md={12}>
            <Form.Group>
              <Form.Label>Created At</Form.Label>
              <Form.Control
                type="datetime-local"
                name="created_at"
                value={formData.created_at}
                disabled
              />
            </Form.Group>
          </Col> */}
          {/* Checkbox + Day Dropdown */}
                    <Col lg={6} md={12}>
                      <Row>
                        {/* Checkbox */}
                        <Col md={6} sm={12}>
                          <Form.Group className="mt-4">
                            <Form.Check
                              type="checkbox"
                              label="Auto Creation"
                              name="auto_creation"
                              checked={formData.auto_creation === 1}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  auto_creation: e.target.checked ? 1 : 0,
                                })
                              }
                            />
                          </Form.Group>
                        </Col>
          
                        {/* Day Dropdown */}
                        <Col md={6} sm={12}>
                          <Form.Group>
                            <Form.Label>Day</Form.Label>
                            <Form.Select
                              name="day"
                              value={formData.day}
                              onChange={handleChange}
                            >
                              <option value="">Select Day</option>
                              <option value="Sunday">Sunday</option>
                              <option value="Monday">Monday</option>
                              <option value="Tuesday">Tuesday</option>
                              <option value="Wednesday">Wednesday</option>
                              <option value="Thursday">Thursday</option>
                              <option value="Friday">Friday</option>
                              <option value="Saturday">Saturday</option>
                            </Form.Select>
                          </Form.Group>
                        </Col>
                      </Row>
                    </Col>
        </Row>

        {/* Submit / Cancel Buttons */}
        <div className="form-actions mt-4 d-flex justify-content-end gap-2">
          <Button type="submit" className="btn-submit">
            Submit
          </Button>
          <Button className="btn-top" onClick={() => navigate(-1)}>
            Cancel
          </Button>
        </div>
      </Form>
    </Container>
  );
};

export default AddTask;
